// extracted by mini-css-extract-plugin
export default {"billsItemsTable":"styles_billsItemsTable__8QIfA"};